module.exports = __webpack_public_path__ + "img/1516423562.1076e6c9.jpg";